export default __webpack_public_path__ + "static/media/approved-status.777a2e87.svg";